import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitle } from '@configs/routes';

const DEFAULT_TITLE = 'EyeT 데이터 분석 도구';

/**
 * 라우트 변경 시 페이지 스크롤을 최상단으로 이동시키고, 페이지 제목을 업데이트하는 훅
 */
export const useRouteChangeHandler = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 스크롤을 최상단으로 이동
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });

    // 페이지 제목 업데이트
    const pageTitle = getPageTitle(pathname);
    // 홈 페이지(/)에서는 "- 홈"을 붙이지 않음
    if (pageTitle && pathname !== '/') {
      document.title = `${DEFAULT_TITLE} - ${pageTitle}`;
    } else {
      document.title = DEFAULT_TITLE;
    }
  }, [pathname]);
};
